// src/pages/ContactUs.jsx
import React, { useState, useEffect } from 'react';
import styles from './ContactUs.module.css';
import ContactDetails from '../components/contact/ContactDetails';
import GoogleMap from '../components/contact/GoogleMap';

const ContactUs = () => {
  const [motto, setMotto] = useState('');
  const fullMotto = "Let's Connect and Shape the  Future of Tech Together";
  const typingSpeed = 100;

  // Define two addresses as an array
  const officeLocations = [
    {
      type: "Location",
      address: "54, Civil Aviation Colony Nanganallur ",
      city: "Chennai, Tamil Nadu",
      pincode: "600002",
    },
    // {
    //   type: "Corporate Office",
    //   address: "MSP Complex, Second Floor,No.135/71 Medavakkam Main Road,Ullagaram,Madipakkam ",
    //   city: "Chennai, Tamil Nadu",
    //   pincode: "600119 Landmark: Opposite to Kumaran Theater",
    // },
  ];

  // Define the common phone and email
  const commonPhone = "+91 7200702908";
  const commonEmail = "info@bsparksoftwaretechnologies.com";

  useEffect(() => {
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < fullMotto.length) {
        setMotto(fullMotto.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, typingSpeed);

    return () => clearInterval(typingInterval);
  }, []);
   useEffect(() => {
        document.title = "Contact us for IT Courses & Queries || Bspark Software Technologies";
      }, []); // The empty dependency array ensures this runs only once
    
  return (
    <div className={styles.contactUsPage}>
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}>
          {/* <div className={styles.breadcrumb}>
            <Link to="/">Home</Link> > <span>Contact Us</span>
          </div> */}
          <h1 className={styles.heroTitle}>Get in Touch</h1>
          <p className={styles.heroMotto} data-motto={motto}>
            {motto}
            <span className={styles.typingCursor}>|</span>
          </p>
        </div>
      </section>

      <section className={styles.contactInfoSection}>
        <div className={styles.container}>
          <div className={styles.contactDetailsWrapper}>
            <h2 className={styles.sectionHeading}>Our Offices</h2>
            {/* Pass the offices array and common details as props */}
            <ContactDetails 
              offices={officeLocations}
              phone={commonPhone}
              email={commonEmail}
            />
          </div>
          <div className={styles.mapWrapper}>
            <h2 className={styles.sectionHeading}>Find Us Here</h2>
            <GoogleMap city="Chennai" region="Tamil Nadu" country="India" />
          </div>
        </div>
      </section>

      {/* <section className={styles.enquiryFormSection}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Send Us a Message</h2>
          <EnquiryForm />
        </div>
      </section> */}
    </div>
  );
};

export default ContactUs;